import { AppSetting, AppSettingKey } from '../../taskManagementApi.types'

export interface GetAppSettingResponse<K extends AppSettingKey> {
  data: AppSetting<K>
}
